
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import InputText from '@/components/molecules/InputText.vue'
import InputPassword from '@/components/molecules/InputPassword.vue'
import SquareSelect from '@/components/molecules/SquareSelect.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import { SelectItem } from '@/models/SelectItem'
import StringUtils from '@/utils/StringUtils'

/**
 * 生徒情報更新モーダルのフォーマット
 */
@Component({
  components: {
    LabelBase,
    ImageBase,
    ModalWindow,
    InputText,
    InputPassword,
    SquareSelect,
    ButtonSubmit,
  },
})
export default class ModalEditStudentData extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** 学年選択コンポーネント */
  @Ref()
  gradeSelect!: SquareSelect

  /** 教室選択コンポーネント */
  @Ref()
  branchSelect!: SquareSelect

  /** コース選択コンポーネント */
  @Ref()
  courseSelect!: SquareSelect

  /** クラス選択コンポーネント */
  @Ref()
  classSelect!: SquareSelect

  /** 学年選択肢 */
  @Prop()
  private gradeOptions!: SelectItem

  /** 学年選択の初期値 */
  @Prop()
  private defaultGradeCode!: string

  /** 教室選択肢 */
  @Prop()
  private branchOptions!: SelectItem

  /** 教室選択の初期値 */
  @Prop()
  private defaultBranchCode!: string

  /** コース選択肢 */
  @Prop()
  private courseOptions!: SelectItem

  /** コース選択の初期値 */
  @Prop()
  private defaultCourseCode!: string

  /** クラス選択肢 */
  @Prop()
  private classOptions!: SelectItem

  /** クラス選択の初期値 */
  @Prop()
  private defaultClassCode!: string

  /** コース選択変更時のイベント */
  @Prop()
  private changeCourseSelect!: () => Promise<void>

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** ニックネーム */
  public nickname: string = ''

  /** 生徒識別子 */
  public identifyTag: string = ''

  /** 選択項目の選択状況フラグ(全て選択済ならtrue) */
  private isOptionsSelected = true

  /**
   * 送信ボタンのdisabled制御
   *
   * @returns 未入力や未選択があった場合はtrue
   */
  private get submitDisabled(): boolean {
    return !this.isNicknameInputed || !this.isOptionsSelected
  }

  /**
   * ニックネームの入力チェック
   *
   * @returns 入力済ならtrue
   */
  private get isNicknameInputed(): boolean {
    return !StringUtils.isBlank(this.nickname)
  }

  /**
   * 選択項目変更時の処理
   *   各項目が選択済かを判定
   */
  private changeOptions(): void {
    if (!this.gradeSelect.selectedValue()) {
      this.isOptionsSelected = false
      return
    }

    if (!this.courseSelect.selectedValue()) {
      this.isOptionsSelected = false
      return
    }

    if (!this.classSelect.selectedValue()) {
      this.isOptionsSelected = false
      return
    }

    if (this.$scopedSlots.selectBranchLabel && !this.branchSelect.selectedValue()) {
      this.isOptionsSelected = false
      return
    }

    this.isOptionsSelected = true
  }

  /**
   * コース変更時の処理
   *   2つのメソッドを発火させるためのラッパーメソッド
   */
  private async changeCourse(): Promise<void> {
    // 選択項目変更時の判定処理
    this.changeOptions()

    // コース選択変更時にクラス選択を更新
    await this.changeCourseSelect()
  }

  /**
   * モーダルを開く
   *
   * @param nickname ニックネーム
   * @param identifyTag 生徒識別子
   */
  public show(nickname: string, identifyTag: string | null): void {
    this.nickname = nickname
    this.identifyTag = identifyTag || ''
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
